jQuery(document).ready(function() {
  
  	var windowScreenSize = jQuery(window).width();
  
  	// Enabling the bottom homepage banner slick slider
    jQuery('.influencer-slider').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
      	responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  	// Enabling the bottom homepage banner slick slider
    jQuery('.homepage-slider-top').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
  
    // Enabling the bottom homepage banner slick slider
    jQuery('.homepage-slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        adaptiveHeight: true,
    });
  
  
  	jQuery("nav ul li.site-nav--has-dropdown").hover( function (e) {
      	jQuery(this).toggleClass('site-nav--active-dropdown');
  	});
  
  	jQuery(document).on('click', '.youtube-video .youtube-video__inner .video-thumbnail.video-desktop', function(){ 
        jQuery(this).hide();  
      
      	var autoPlay = '?autoplay=1';
      
      	var url = $('.youtube-video .youtube-video__inner iframe').attr('src');
      	jQuery('.youtube-video .youtube-video__inner iframe').attr('src', url + autoPlay);
    });
  
  
  	jQuery(document).on('click', '.youtube-video .youtube-video__inner .video-thumbnail.video-mobile', function(){ 
        jQuery(this).hide();  
      
      	var autoPlay = '?autoplay=1';
      
      	var url = $('.youtube-video .youtube-video__inner iframe').attr('src');
      	jQuery('.youtube-video .youtube-video__inner iframe').attr('src', url + autoPlay);
    });
  
  	jQuery(document).on('click', '.product-additional_information .dropdown-block .tab-title', function(){  
      	jQuery('.product-additional_information .dropdown-block .tab-title').removeClass('show');
      	jQuery('.product-additional_information .dropdown-block .tab-content').removeClass('show');
      	
      	jQuery(this).addClass('show'); 
        jQuery(this).next('.tab-content').addClass('show');                
    });
      
  
  	jQuery(document).on('click', '.site-footer__newsletter-header .close-icon-wrapper', function(e){
      	e.preventDefault();
      	jQuery('.site-footer__newsletter.popup').hide();
    
  	})
    
    if(windowScreenSize < 990) {
      
      	jQuery(document).on('click', '.redesign-footer .link-block .link-block--inner h4', function(e){
            e.preventDefault();
            jQuery(this).parents('.link-block--inner').toggleClass('active-mobile-menu');

        });
      
      
        // Enabling the logo list within the footer
        jQuery('.mobile-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 670,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
        });
      
      	// Enabling the shop by collection slider
        jQuery('.shop-by-collection-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  dots: true,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      
      	// Enabling the shop by fragrance slider
        jQuery('.shop-by-fragrance-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
    }
});

jQuery(window).load(function() {
  
      var windowScreenSize = jQuery(window).width();
  
      if(windowScreenSize < 990) {
        // Enabling the logo list within the footer
        jQuery('.mobile-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 670,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
        });
        
        // Enabling the shop by collection slider
        jQuery('.shop-by-collection-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  dots: true,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      
      	// Enabling the shop by fragrance slider
        jQuery('.shop-by-fragrance-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
    }
});

jQuery(window).resize(function() {
  
  	  var windowScreenSize = jQuery(window).width();
  
      if(windowScreenSize < 990) {
        // Enabling the logo list within the footer
        jQuery('.mobile-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 670,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
        });
        
              	// Enabling the shop by collection slider
        jQuery('.shop-by-collection-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  dots: true,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      
      	// Enabling the shop by fragrance slider
        jQuery('.shop-by-fragrance-slider').slick({
          arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  dots: true,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
    }
});
